/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<5bd8901b8b80a49cd809b3b059c2a733>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from "relay-runtime";
import type { FragmentRefs } from "relay-runtime";
export type helpObject$data = {
  readonly node: {
    readonly data: {
      readonly __typename: "HelpObjectStoreArticle";
      readonly entityKey: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"helpObjectStoreArticle">;
    } | {
      readonly __typename: "HelpObjectStoreChannel";
      readonly entityKey: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"helpObjectStoreChannel">;
    } | {
      readonly __typename: "HelpObjectStoreQueryError";
      readonly __typename: "HelpObjectStoreQueryError";
    } | {
      readonly __typename: "HelpObjectStoreRequestForm";
      readonly entityKey: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"helpObjectRequestForm">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly " $fragmentType": "helpObject";
};
export type helpObject$key = {
  readonly " $data"?: helpObject$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityKey",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "helpObject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterTopicItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "helpObjectRequestForm"
                },
                (v0/*: any*/)
              ],
              "type": "HelpObjectStoreRequestForm",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "helpObjectStoreArticle"
                },
                (v0/*: any*/)
              ],
              "type": "HelpObjectStoreArticle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "helpObjectStoreChannel"
                },
                (v0/*: any*/)
              ],
              "type": "HelpObjectStoreChannel",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpCenterTopicItemEdge",
  "abstractKey": null
};
})();

(node as any).hash = "f16e56b13232df08cf4bd8d914f62028";

export default node;
